(() => {
  const syncActivePanels = (scope = document) => {
    scope.querySelectorAll('.accordion.active').forEach((button) => {
      const panel = button.nextElementSibling;

      if (!panel?.classList.contains('panel') || panel.classList.contains('js-flowbox-panel')) {
        return;
      }

      if (!panel.style.maxHeight) return;

      panel.style.maxHeight = `${panel.scrollHeight}px`;
    });
  };

  const openActivePanels = (scope) => {
    scope.querySelectorAll('.accordion.active').forEach((button) => {
      const panel = button.nextElementSibling;

      if (!panel?.classList.contains('panel') || panel.classList.contains('js-flowbox-panel')) {
        return;
      }

      const setHeight = () => {
        panel.style.maxHeight = `${panel.scrollHeight}px`;
      };

      setHeight();
      setTimeout(setHeight, 2000);
    });
  };

  window.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.product-tabs .tab, .additional-tab .tab').forEach(openActivePanels);

    let resizeTimer;
    window.addEventListener('resize', () => {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(() => {
        syncActivePanels();
      }, 100);
    });
  });
})();
